import React from 'react';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';
import store from 'store';
import Api from '../../api/api';
import AppAuthStore from '../../stores/login-store';
import { SERVER_ERROR } from '../../constants/messages';
import SettingsNotice from '../../components/notices/notice';
import AuthMixin from '../../mixins/authenticationMixin';
import Loading from '../../components/loading/loading';
import AppRoutes from '../../routes/logged-in';
import './user-details.scss';
import '../../../css/design-system.scss';

class ChangePassword extends React.Component {
  constructor(){
    super();
    this.currentPasswordRef = React.createRef();
    this.passwordRef = React.createRef();
    this.confirmPasswordRef = React.createRef();
    this.state = {
      success: false,
      errors: false,
      errorMsgs: {},
      loading: false
    };
  }

  validateData(data){
    let errors = {};
    if(Api.hasEmptyFields(data)) {
      errors['empty_fields'] = "Please complete all fields";
    }

    if(data.password !== data.confirm_password) {
      errors['mismatch'] = "Your new password did not match";
    }

    // the API's limits; checking them here means a 422 can only be a wrong current password
    if(data.password && (data.password.length < 8 || data.password.length > 72)) {
      errors['length'] = "Your new password must be between 8 and 72 characters";
    }

    if(Object.keys(errors).length){
      return { errors:true, errorMsgs: errors };
    }

    return { errors: false };
  }

  handleSubmit(e){
    e.preventDefault();

    this.setState({ loading: true })

    let data = {
      current_password: this.currentPasswordRef.current.value,
      password: this.passwordRef.current.value,
      confirm_password: this.confirmPasswordRef.current.value
    };

    let isValid = this.validateData(data);

    if(isValid.errors){
      return this.setState({
        errors:true,
        errorMsgs: isValid.errorMsgs,
        loading: false
      })
    }

    AppAuthStore.updateUserPassword(this.props.userApiRequest, data, {
      onSuccess: ({data}) => {
        this.setState({
          errors: false,
          success: true,
          errorMsgs: {},
          loading: false
        });
        setTimeout( () => {
          store.clearAll();
          window.location.reload();
        }, 500);
      },
      onError: ({ response }) => {
        const wrongPassword = response && response.statusCode === 422;
        this.setState({
          errors: true,
          success: false,
          errorMsgs: {
            serverError: wrongPassword ? "Your current password is incorrect" : SERVER_ERROR
          },
          loading: false
        });
      }
    });
  }

  renderErrorMessages(){
    const messages = Object.values(this.state.errorMsgs);
    if (messages.length === 1) return messages[0];
    return <ul>{messages.map((message) => <li key={message}>{message}</li>)}</ul>;
  }

  renderNotice(){
    if (!this.state.errors) {
      return <SettingsNotice type="success">Password updated. Signing you out…</SettingsNotice>;
    }
    return <SettingsNotice type="error">{this.renderErrorMessages()}</SettingsNotice>;
  }

  render(){
    let notice = (this.state.errors || this.state.success)? this.renderNotice() : null;

    return (
      <div className="settings-modern-page">
        <Helmet>
          <title>Neurochecklists | Change Password</title>
        </Helmet>

        <div className="settings-form-wrap">

          <div className="settings-page-header">
            <h1 className="section-title">Change Password</h1>
            <p className="section-sub">You'll be signed out on all your devices once your password has changed.</p>
          </div>

          {notice}

          <form onSubmit={this.handleSubmit.bind(this)}>
            {(this.state.loading)? <Loading text="Please wait..." /> : null }

            <div className="input-group settings-input-row">
              <label className="input-label" htmlFor="current_password">Current Password</label>
              <input
                ref={this.currentPasswordRef}
                id="current_password"
                name="current_password"
                className="input-field"
                type="password"
                autoComplete="current-password"
                required
              />
            </div>

            <div className="input-group settings-input-row">
              <label className="input-label" htmlFor="password">New Password</label>
              <input
                ref={this.passwordRef}
                id="password"
                name="password"
                className="input-field"
                type="password"
                autoComplete="new-password"
                required
              />
            </div>

            <div className="input-group settings-input-row">
              <label className="input-label" htmlFor="confirm_password">Confirm New Password</label>
              <input
                ref={this.confirmPasswordRef}
                id="confirm_password"
                name="confirm_password"
                className="input-field"
                type="password"
                autoComplete="new-password"
                required
              />
            </div>

            <div className="settings-form-actions">
              <Link to={AppRoutes.account} className="settings-back-link">Back to your profile</Link>
              <button type="submit" className="btn btn-primary-sm">Update Password</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}


export default AuthMixin(ChangePassword);
